var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",null,{"items":_vm.items}),_c('InfiniteLoader',{attrs:{"loading":_vm.loading,"has-more":_vm.hasMore},on:{"load-more":_vm.loadMore}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }